import appBarCode from "../../assets/appBarCode.png";
import DownlaodAppImage from "../../assets/download-page-image.png";
import { Typography } from "antd";
import { Link } from "react-router-dom";
import WPLayout from "../../components/WPLayout/WPLayout";

const SignInWelcome = () => {
  return (
    <WPLayout>
      <div className="mt-8 mb-4 w-full flex flex-col max-w-[1440px] px-6 py-4 mx-auto justify-center items-center gap-y-8 sm:flex-row-reverse sm:gap-x-12 sm:items-start">
        <div className="flex flex-col justify-center items-center gap-y-4 w-full max-w-[480px]">
          <Typography.Text className="font-playfair w-full font-semibold text-3xl leading-[110%] tracking-tight sm:font-bold sm:text-[52px] sm:tracking-[-2%]">
            Thank You!
          </Typography.Text>
          <Typography.Text className="font-urbanist w-full text-[25px] leading-5 align-middle sm:leading-[100%] sm:font-poppins sm:tracking-tight">
            You're all set to start using the app.
          </Typography.Text>
          <div className="flex flex-col gap-y-4 w-full">
            <Typography.Text className="mb-2 font-bold text-lg font-poppins text-left w-full leading-[157%]">
              1. Scan the QR code below to download the DocUpdate app.
            </Typography.Text>
            <Typography.Text className="font-bold text-lg font-poppins text-left w-full leading-[157%]">
              2. Log in using the email and password you just used to sign up.
              <br />
              <span>(Your email is your username.) </span>
            </Typography.Text>
          </div>
          <div className="hidden mt-4 sm:flex flex-col gap-y-4 w-full">
            <img
              src={appBarCode}
              className="ml-1 p-3 bg-white rounded-lg w-full max-w-32 app-bar-code-shadow"
            />
          </div>
        </div>
        <Link
          to={"https://docupdate.onelink.me/j4xR/desktop"}
          className="my-3 text-white text-base font-semibold font-inter py-2 px-4 bg-[#7e5ae2] rounded-full border-none transition-all duration-300 ease-in-out hover:bg-[#101935] flex justify-center items-center sm:hidden w-full max-w-[300px]"
        >
          Get the App
        </Link>
        <div className="min-w-[300px] w-full max-w-[415px] lg:ml-[7rem]">
          <img
            src={DownlaodAppImage}
            alt="download-image"
            className="object-contain w-full object-right"
          />
        </div>
      </div>
    </WPLayout>
  );
};

export default SignInWelcome;